import React from "react";

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row copyright">
          <div className="m-auto">
            Copyright 2020 • All rights reserved • KICKSHOES
          </div>
        </div>
      </div>
    </footer>
  );
}
